import Tile from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { OSM } from 'ol/source';
import Stamen from 'ol/source/Stamen';
import XYZ from 'ol/source/XYZ';

function getMapByName(title: string, baseMaps: any) {
  const data = baseMaps.filter((data: any) => {
    return data.title == title;
  });

  if (data) {
    const getData = data[0];
    return getData;
  }
}


export function getBasemapData(baseMaps: any, baseMapsData: any, mapservices: any) {
  const layers = []; let data = '';
  const currYear = new Date().getFullYear();
  if (baseMapsData.name === 'Alameda Counties') {
    data = `Map data &copy;${currYear}  imagery &copy;${currYear} TerraMetrics <a target="_blank">| Terms of Use. <a target="_blank" rel="noopener" title="Report errors in the road map or imagery to Google" dir="ltr" style="font-size: 10px; color: rgb(0, 0, 0); text-decoration: none; position: relative;">| Report a map error</a>`
  } else if (baseMapsData.name === 'Camp Fire') {
    data = `Map data &copy;${currYear}  imagery &copy;${currYear}  TerraMetrics <a  target="_blank">| Terms of Use. <a target="_blank" rel="noopener" title="Report errors in the road map or imagery to Google" dir="ltr" style="font-size: 10px; color: rgb(0, 0, 0); text-decoration: none; position: relative;">| Report a map error</a>`
  } else {
    data = `Map data &copy;${currYear} INEGI  Imagery &copy;${currYear} NASA, TerraMetrics <a target="_blank">| Terms of Use.`
  }
  if (getMapByName('blank', baseMaps).status) {
    // Blank Basemap:
    const tileLayer = new Tile({
      source: new OSM(),
      visible: mapservices.baseLayerName === 'Blank' ? true : false,
    });
    tileLayer.setProperties({ title: 'blank' }),
      tileLayer.setProperties({ displayInLayerSwitcher: true }),
      tileLayer.setProperties({ isBaseLayer: true }),
      tileLayer.setProperties({ share_name: 'blank' }),
      tileLayer.setProperties({ loadend: true }),
      tileLayer.setProperties({ type: 'baseMaps' });
    tileLayer.setProperties({ order: getMapByName('blank', baseMaps).order })
    tileLayer.setProperties({ index: getMapByName('blank', baseMaps).index })
    layers.push(tileLayer);
  }
  if (getMapByName('google-imagery', baseMaps).status) {
    const tileLayer = new Tile({
      source: new OSM({
        url: 'https://mt{0-3}.google.com/vt/hl=en-US&lyrs=s&x={x}&y={y}&z={z}',
        attributions: data
      }),

      visible: mapservices.baseLayerName === 'Google Imagery' ? true : false,
      // maxZoom: baseMapsData.maxzoom,
      // minZoom: baseMapsData.minzoom,
      // Google Imagery

    });
    // tileLayer.setVisible(true);
    tileLayer.setProperties({ title: 'google-imagery' }),
      tileLayer.setProperties({ displayInLayerSwitcher: true }),
      tileLayer.setProperties({ isBaseLayer: true }),
      tileLayer.setProperties({ share_name: 'google-imagery' }),
      tileLayer.setProperties({ loadend: true }),
      tileLayer.setProperties({ type: 'baseMaps' });
    tileLayer.setProperties({ order: getMapByName('google-imagery', baseMaps).order })
    tileLayer.setProperties({ index: getMapByName('google-imagery', baseMaps).index })
    layers.push(tileLayer);
  }
  if (getMapByName('google-hybrid', baseMaps).status) {
    const baselayer = new Tile({
      source: new OSM({
        url: 'https://mt{0-3}.google.com/vt/hl=en-US&lyrs=y&x={x}&y={y}&z={z}',
        attributions: data,
        maxZoom: baseMapsData.maxzoom,

      }),
      // modified by anas

      visible: mapservices.baseLayerName === 'Google Hybrid' ? true : false,


    });
    baselayer.setProperties({ title: 'google-hybrid' }),
      baselayer.setProperties({ displayInLayerSwitcher: true }),
      baselayer.setProperties({ isBaseLayer: true }),
      baselayer.setProperties({ share_name: 'google-hybrid' }),
      baselayer.setProperties({ loadend: true }),
      baselayer.setProperties({ type: 'baseMaps' });
    baselayer.setProperties({ order: getMapByName('google-hybrid', baseMaps).order })
    baselayer.setProperties({ index: getMapByName('google-hybrid', baseMaps).index })
    layers.push(baselayer);
  }
  if (getMapByName('google-terrain', baseMaps).status) {
    const baselayer = new Tile({
      source: new OSM({
        url: 'https://mt{0-3}.google.com/vt/hl=en-US&lyrs=p&x={x}&y={y}&z={z}',
        attributions:
          'Map data ©2021 <a href="https://developers.google.com/maps/terms" target="_blank"> Terms of Use.</a>Report a map error',
      }),
      visible: mapservices.baseLayerName === 'Google Terrain' ? true : false,

    });

    baselayer.setProperties({ title: 'google-terrain' }),
      baselayer.setProperties({ displayInLayerSwitcher: true }),
      baselayer.setProperties({ isBaseLayer: true }),
      baselayer.setProperties({ share_name: 'google-terrain' }),
      baselayer.setProperties({ loadend: true }),
      baselayer.setProperties({ type: 'baseMaps' });
    baselayer.setProperties({ order: getMapByName('google-terrain', baseMaps).order })
    baselayer.setProperties({ index: getMapByName('google-terrain', baseMaps).index })
    layers.push(baselayer);
  }
  if (getMapByName('google-roadmap', baseMaps).status) {

    const baselayer = new Tile({
      source: new OSM({
        url: 'https://mt1.google.com/vt/lyrs=m@113&hl=en&&x={x}&y={y}&z={z}',
        attributions:
          '© Google <a href="https://developers.google.com/maps/terms">Terms of Use.</a>',
      }),
      visible: mapservices.baseLayerName === 'Google Roadmap' ? true : false,
    });
    baselayer.setProperties({ title: 'google-roadmap' }),
      baselayer.setProperties({ displayInLayerSwitcher: true }),
      baselayer.setProperties({ isBaseLayer: true }),
      baselayer.setProperties({ share_name: 'google-roadmap' }),
      baselayer.setProperties({ loadend: true }),
      baselayer.setProperties({ type: 'baseMaps' });
    baselayer.setProperties({ order: getMapByName('google-roadmap', baseMaps).order })
    baselayer.setProperties({ index: getMapByName('google-roadmap', baseMaps).index })
    layers.push(baselayer);
  }
  if (getMapByName('stamen-terrain', baseMaps).status) {
    const baselayer = new Tile({
      source: new Stamen({
        layer: 'terrain',
        maxZoom: getMapByName('stamen-terrain', baseMaps).zoom,
      }),
      visible: mapservices.baseLayerName === 'Stamen Terrain' ? true : false,
    });
    baselayer.setProperties({ title: 'stamen-terrain' }),
      baselayer.setProperties({ displayInLayerSwitcher: true }),
      baselayer.setProperties({ isBaseLayer: true }),
      baselayer.setProperties({ share_name: 'stamen-terrain' }),
      baselayer.setProperties({ type: 'baseMaps' });
    baselayer.setProperties({ order: getMapByName('stamen-terrain', baseMaps).order })
    baselayer.setProperties({ index: getMapByName('stamen-terrain', baseMaps).index })
    layers.push(baselayer);
  }
  if (getMapByName('stamen-toner', baseMaps).status) {
    const baselayer = new Tile({
      source: new Stamen({
        layer: 'toner',
        maxZoom: getMapByName('stamen-toner', baseMaps).zoom,
      }),
      visible: mapservices.baseLayerName === 'Stamen Toner' ? true : false,
    });
    baselayer.setProperties({ title: 'stamen-toner' }),
      baselayer.setProperties({ displayInLayerSwitcher: true }),
      baselayer.setProperties({ isBaseLayer: true }),
      baselayer.setProperties({ share_name: 'stamen-toner' }),
      baselayer.setProperties({ type: 'baseMaps' });
    baselayer.setProperties({ order: getMapByName('stamen-toner', baseMaps).order })
    baselayer.setProperties({ index: getMapByName('stamen-toner', baseMaps).index })
    layers.push(baselayer);
  }
  if (getMapByName('stamen-watercolor', baseMaps).status) {
    const baselayer = new Tile({
      source: new Stamen({
        layer: 'watercolor',
        maxZoom: getMapByName('stamen-watercolor', baseMaps).zoom,
      }),
      visible: mapservices.baseLayerName === 'Stamen Watercolor' ? true : false,
    });
    baselayer.setProperties({ title: 'stamen-watercolor' }),
      baselayer.setProperties({ displayInLayerSwitcher: true }),
      baselayer.setProperties({ isBaseLayer: true }),
      baselayer.setProperties({ share_name: 'stamen-watercolor' }),
      baselayer.setProperties({ type: 'baseMaps' });
    baselayer.setProperties({ order: getMapByName('stamen-watercolor', baseMaps).order })
    baselayer.setProperties({ index: getMapByName('stamen-watercolor', baseMaps).index })
    layers.push(baselayer);
  }
  if (getMapByName('mapbox-terrain', baseMaps).status) {
    const layer = new Tile({
      source: new XYZ({
        urls: [
          'https://a.tiles.mapbox.com/v4/enplan.jgoejdob/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
          'https://b.tiles.mapbox.com/v4/enplan.jgoejdob/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
          'https://c.tiles.mapbox.com/v4/enplan.jgoejdob/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
          'https://d.tiles.mapbox.com/v4/enplan.jgoejdob/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
        ],
        transition: 0,
        maxZoom: getMapByName('mapbox-terrain', baseMaps).zoom,
      }),
      // minResolution: viz.slice(-1)[0],
      visible: mapservices.baseLayerName === 'Mapbox Terrain' ? true : false,
    });
    // Shaded Relief Basemap:
    layer.setProperties({ title: 'mapbox-terrain' });
    layer.setProperties({ displayInLayerSwitcher: true }),
      layer.setProperties({ isBaseLayer: true }),
      layer.setProperties({ share_name: 'mapbox-terrain' }),
      layer.setProperties({ type: 'baseMaps' });
    layer.setProperties({ order: getMapByName('mapbox-terrain', baseMaps).order })
    layer.setProperties({ index: getMapByName('mapbox-terrain', baseMaps).index })
    layers.push(layer);
  }
  if (getMapByName('mapbox-hybrid', baseMaps).status) {
    const layer = new Tile({
      source: new XYZ({
        urls: [
          'https://a.tiles.mapbox.com/v3/enplan.hok3chhf/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
          'https://b.tiles.mapbox.com/v3/enplan.hok3chhf/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
          'https://c.tiles.mapbox.com/v3/enplan.hok3chhf/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
          'https://d.tiles.mapbox.com/v3/enplan.hok3chhf/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
        ],
        transition: 0,
        maxZoom: getMapByName('mapbox-hybrid', baseMaps).zoom,
      }),
      // minResolution: viz.slice(-1)[0],
      visible: mapservices.baseLayerName === 'Mapbox Hybrid' ? true : false,
    });
    // Shaded Relief Basemap:
    layer.setProperties({ title: 'mapbox-hybrid' }),
      layer.setProperties({ displayInLayerSwitcher: true }),
      layer.setProperties({ isBaseLayer: true }),
      layer.setProperties({ share_name: 'mapbox-hybrid' }),
      layer.setProperties({ type: 'baseMaps' });
    layer.setProperties({ order: getMapByName('mapbox-hybrid', baseMaps).order })
    layer.setProperties({ index: getMapByName('mapbox-hybrid', baseMaps).index })
    layers.push(layer);
  }
  if (getMapByName('mapbox-simple', baseMaps).status) {
    const layer = new Tile({
      source: new XYZ({
        urls: [
          'https://a.tiles.mapbox.com/v4/enplan.jd8gh78h/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
          'https://b.tiles.mapbox.com/v4/enplan.jd8gh78h/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
          'https://c.tiles.mapbox.com/v4/enplan.jd8gh78h/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
          'https://d.tiles.mapbox.com/v4/enplan.jd8gh78h/{z}/{x}/{y}.jpg?access_token=pk.eyJ1IjoiZW5wbGFuIiwiYSI6InBKSG9jWUUifQ.VB6R5pUsOD0qrWXScOs3pw',
        ],
        transition: 0,
        maxZoom: getMapByName('mapbox-simple', baseMaps).zoom,
      }),
      visible: mapservices.baseLayerName === 'MapBox Simple' ? true : false,
    });
    // Shaded Relief Basemap:
    layer.setProperties({ title: 'mapbox-simple' }),
      layer.setProperties({ displayInLayerSwitcher: true }),
      layer.setProperties({ isBaseLayer: true }),
      layer.setProperties({ share_name: 'mapbox-simple' }),
      layer.setProperties({ type: 'baseMaps' });
    layer.setProperties({ order: getMapByName('mapbox-simple', baseMaps).order })
    layer.setProperties({ index: getMapByName('mapbox-simple', baseMaps).index })
    layers.push(layer);
  }
  if (getMapByName('enplan-imagery', baseMaps).status) {
    const layer = new Tile({
      source: new XYZ({
        urls: [
          'https://1.mapport.net/newtiles/enplan/ortho/{z}/{x}/{y}.jpg',
          'https://2.mapport.net/newtiles/enplan/ortho/{z}/{x}/{y}.jpg',
          'https://3.mapport.net/newtiles/enplan/ortho/{z}/{x}/{y}.jpg',
          'https://4.mapport.net/newtiles/enplan/ortho/{z}/{x}/{y}.jpg',
          'https://5.mapport.net/newtiles/enplan/ortho/{z}/{x}/{y}.jpg',
        ],
        transition: 0,
      }),
      visible: mapservices.baseLayerName === 'ENPLAN Imagery' ? true : false,
    });
    // Shaded Relief Basemap:
    layer.setProperties({ title: 'enplan-imagery' }),
      layer.setProperties({ displayInLayerSwitcher: true }),
      layer.setProperties({ isBaseLayer: true }),
      layer.setProperties({ share_name: 'enplan-imagery' }),
      layer.setProperties({ type: 'baseMaps' });
    layer.setProperties({ order: getMapByName('enplan-imagery', baseMaps).order })
    layer.setProperties({ index: getMapByName('enplan-imagery', baseMaps).index })
    layers.push(layer);
  }
  if (getMapByName('us-topo', baseMaps).status) {
    // MapBox Tiles:
    const layer = new Tile({
      source: new TileWMS({
        url: 'https://basemap.nationalmap.gov/arcgis/services/USGSTopo/MapServer/WMSServer',
        params: {
          FORMAT: 'image/png',
          LAYERS: '0',
          TILED: true,
        },
        projection: 'EPSG:3857',
        crossOrigin: 'anonymous',
      }),
      // alpha: false,
      visible: mapservices.baseLayerName === 'US Topo' ? true : false,
    });
    layer.setProperties({ title: 'us-topo' }),
      layer.setProperties({ displayInLayerSwitcher: true }),
      layer.setProperties({ isBaseLayer: true }),
      layer.setProperties({ share_name: 'us-topo' }),
      layer.setProperties({ type: 'baseMaps' });
    layer.setProperties({ order: getMapByName('us-topo', baseMaps).order })
    layer.setProperties({ index: getMapByName('us-topo', baseMaps).index })
    layers.push(layer);
  }
  if (getMapByName('naip-imagery', baseMaps).status) {
    // MapBox Tiles:
    const layer = new Tile({
      source: new TileWMS({
        url: 'https://basemap.nationalmap.gov/arcgis/services/USGSImageryOnly/MapServer/WMSServer',
        params: {
          FORMAT: 'image/png',
          LAYERS: '0',
          TILED: true,
        },
        projection: 'EPSG:3857',
        crossOrigin: 'anonymous',
      }),
      visible: mapservices.baseLayerName === 'NAIP Imagery' ? true : false,
    });
    layer.setProperties({ title: 'naip-imagery' }),
      layer.setProperties({ displayInLayerSwitcher: true }),
      layer.setProperties({ isBaseLayer: true }),
      layer.setProperties({ share_name: 'naip-imagery' }),
      layer.setProperties({ type: 'baseMaps' });
    layer.setProperties({ order: getMapByName('naip-imagery', baseMaps).order })
    layer.setProperties({ index: getMapByName('naip-imagery', baseMaps).index })
    layers.push(layer);
  }
  if (getMapByName('naip-topo-hybrid', baseMaps).status) {
    // MapBox Tiles:
    const layer = new Tile({
      source: new TileWMS({
        url: 'https://basemap.nationalmap.gov/arcgis/services/USGSImageryTopo/MapServer/WMSServer',
        params: {
          FORMAT: 'image/png',
          LAYERS: '0',
          TILED: true,
        },
        projection: 'EPSG:3857',
        crossOrigin: 'anonymous',
      }),

      visible: mapservices.baseLayerName === 'NAIP Topo Hybrid' ? true : false,
    });
    layer.setProperties({ title: 'naip-topo-hybrid' }),
      layer.setProperties({ displayInLayerSwitcher: true }),
      layer.setProperties({ isBaseLayer: true }),
      layer.setProperties({ share_name: 'naip-topo-hybrid' }),
      layer.setProperties({ type: 'baseMaps' });
    layer.setProperties({ order: getMapByName('naip-topo-hybrid', baseMaps).order })
    layer.setProperties({ index: getMapByName('naip-topo-hybrid', baseMaps).index })
    layers.push(layer);
  }
  if (getMapByName('usgs-imagery-2018', baseMaps).status) {
    const layer = new Tile({
      source: new XYZ({
        urls: [
          'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}',
        ],
      }),
      visible: mapservices.baseLayerName === 'USGS Imagery 2018' ? true : false,
    });
    // Shaded Relief Basemap:
    layer.setProperties({ title: 'usgs-imagery-2018' }),
      layer.setProperties({ displayInLayerSwitcher: true }),
      layer.setProperties({ isBaseLayer: true }),
      layer.setProperties({ share_name: 'usgs-imagery-2018' }),
      layer.setProperties({ type: 'baseMaps' });
    layer.setProperties({ order: getMapByName('usgs-imagery-2018', baseMaps).order })
    layer.setProperties({ index: getMapByName('usgs-imagery-2018', baseMaps).index })
    layers.push(layer);
  }
  if (getMapByName('openstreetmap', baseMaps).status) {
    // OpenStreetMap Basemap:
    const baselayer = new Tile({
      source: new OSM(),
      visible: mapservices.baseLayerName === 'OpenStreetMap' ? true : false,
    });
    baselayer.setProperties({ title: 'openstreetmap' }),
      baselayer.setProperties({ displayInLayerSwitcher: true }),
      baselayer.setProperties({ isBaseLayer: true }),
      baselayer.setProperties({ share_name: 'openstreetmap' }),
      baselayer.setProperties({ type: 'baseMaps' });
    baselayer.setProperties({ order: getMapByName('openstreetmap', baseMaps).order })
    baselayer.setProperties({ index: getMapByName('openstreetmap', baseMaps).index })
    layers.push(baselayer);
  }
  if (getMapByName('naip-2020', baseMaps).status) {
    const layer = new Tile({
      source: new TileWMS({
        url: 'https://map.dfg.ca.gov/arcgis/services/Base_Remote_Sensing/NAIP_2020/ImageServer/WMSServer',
        params: {
          FORMAT: 'image/png',
          LAYERS: '0',
          // transparent: true,
          MINZOOMLEVEL: 8,
        },
        projection: 'EPSG:3857',
        crossOrigin: 'anonymous',
      }),

      visible: mapservices.baseLayerName === 'NAIP 2020' ? true : false,
    });
    layer.setProperties({ title: 'naip-2020' }),
      layer.setProperties({ displayInLayerSwitcher: true }),
      layer.setProperties({ isBaseLayer: true }),
      layer.setProperties({ share_name: 'naip-2020' }),
      layer.setProperties({ type: 'baseMaps' });
    layer.setProperties({ order: getMapByName('naip-2020', baseMaps).order })
    layer.setProperties({ index: getMapByName('naip-2020', baseMaps).index })
    layers.push(layer);
  }
  if (getMapByName('usgs-75-quad', baseMaps).status) {
    const layer = new Tile({
      source: new XYZ({
        url: 'https://caltopo.s3.amazonaws.com/topo/{z}/{x}/{y}.png',
      }),
      visible: mapservices.baseLayerName === 'USGS 7.5 Quad' ? true : false,
    });
    layer.setProperties({ title: 'usgs-75-quad' }),
      layer.setProperties({ displayInLayerSwitcher: true }),
      layer.setProperties({ isBaseLayer: true }),
      layer.setProperties({ share_name: 'usgs-75-quad' }),
      layer.setProperties({ type: 'baseMaps' });
    layer.setProperties({ order: getMapByName('usgs-75-quad', baseMaps).order })
    layer.setProperties({ index: getMapByName('usgs-75-quad', baseMaps).index })
    layers.push(layer);
  }
  return layers;
}
